import { FileSignature } from 'lucide-react';
import { nomeParceiro } from '../../nucleo/formato';
import { caminhoDaAba, type FonteBuscaGlobal } from '../../nucleo/modulos-web';

/** Lista de 30/10 (item 10): contratos de assinatura (número, referência externa ou cliente). Abre o drawer (`?contrato=`). */
interface ContratoBusca {
  id: string;
  numero: string;
  parceiro_nome: string | null;
}

export const buscaAssinaturas: FonteBuscaGlobal[] = [
  {
    chave: 'contratos',
    permissao: 'assinaturas.ver',
    pagina: 'assinaturas.contratos',
    grupo: 'buscaGlobal.contratos',
    posicao: 80,
    icone: FileSignature,
    item: (c: ContratoBusca) => ({ id: c.id, rotulo: `${c.numero} · ${nomeParceiro(c.parceiro_nome)}`, link: `${caminhoDaAba('assinaturas', 'contratos')}?contrato=${c.id}` }),
  },
];
